import { useMutation, useQuery } from 'react-query';
import { request } from '@/utils/request';
import { SpamAppealRecord, SpamMarkRecord } from '../types';
import { setQueryFeedAllUsersInList } from '@/views/Stream';
import { toastError } from '@/utils';
import { setUserDetail, useCurrentAddressInfo } from '@/hooks';

export const useSpamAppealList = ({ enabled }: { enabled?: boolean }) => {
  const { address } = useCurrentAddressInfo();
  return useQuery(
    ['/spam/appeal_list', address],
    () =>
      request.get<{
        appeal_list: SpamAppealRecord[];
      }>('/spam/appeal_list', {
        limit: 100,
        start: 0,
      }),
    {
      enabled: !!address && enabled,
    },
  );
};
export const useSpamMarkList = (id: string) => {
  return useQuery(
    ['/spam/mark_list', id],
    () =>
      request.get<{
        mark_list: SpamMarkRecord[];
      }>('/spam/mark_list', {
        target_id: id,
        limit: 100,
        start: 0,
      }),
    {
      enabled: !!id,
    },
  );
};

export const useSpamDetail = (id: string) => {
  return useQuery(
    ['/spam/detail', id],
    () =>
      request.get<{
        platform: boolean;
        personal?: boolean;
        final: boolean;
      }>('/spam/detail', {
        target_id: id,
      }),
    {
      enabled: !!id,
    },
  );
};

export const useSubmitAppeal = () => {
  return useMutation(({ comment }: { comment: string }) => {
    return request.post<{ appeal: {} }>(`/spam/appeal`, {
      comment,
    });
  });
};
export const useMarkUserSpam = () => {
  return useMutation(
    ({ id, isSpam }: { id: string; isSpam: boolean }) => {
      return request.post<{ appeal: {} }>(`/spam/mark`, {
        target_id: id,
        result: isSpam,
      });
    },
    {
      onError: err => {
        toastError(err);
      },
    },
  );
};
export const setAllUserSybil = ({ currentId, userId }: { currentId: string; userId: string }) => {
  // 更新stream
  const allFeedHandler = (pre?: UnionAccount) => {
    if (pre) {
      (pre as GeneralAccount).desc.is_spam = !(pre as GeneralAccount)?.desc?.is_spam;
    }
  };
  setQueryFeedAllUsersInList(currentId, userId, allFeedHandler);
  // 更新profile
  setUserDetail({
    currentId,
    userId,
    recipe: pre => {
      if (pre.desc) {
        pre.desc.is_spam = !pre.desc?.is_spam;
      }
    },
  });
};

export const setUserBlocked = ({ currentId, userId }: { currentId: string; userId: string }) => {
  // 更新stream
  const allFeedHandler = (pre?: UnionAccount) => {
    if (pre) {
      (pre as GeneralAccount).desc.is_block = !(pre as GeneralAccount)?.desc?.is_block;
    }
  };
  setQueryFeedAllUsersInList(currentId, userId, allFeedHandler);
  // 更新profile
  setUserDetail({
    currentId,
    userId,
    recipe: pre => {
      if (pre.desc) {
        pre.desc.is_block = !pre.desc?.is_block;
      }
    },
  });
};
